import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, input, numberAttribute, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { DataTestidDirective } from '@@shared/data-test-id-directive';

import { ButtonTestIds } from './button-testids.model';

@Component({
	selector: 'sl-button',
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		NgClass,
		MatIcon,
		DataTestidDirective,
	]
})
export class ButtonComponent {
	readonly label = input<string>();
	readonly severity = input<string>('regular');
	readonly icon = input<string>();
	readonly disabled = input(false, {
		transform: booleanAttribute
	});
	readonly type = input<string>('button');
	readonly styleClass = input<string>();
	readonly tabindex = input(0, {
		transform: numberAttribute
	});

	readonly onClick = output();

	readonly ButtonTestIds = ButtonTestIds;
}
